// extracted by mini-css-extract-plugin
export var text = "_ba-0";